import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'setup.territory.header.title' }),
    description: translate({ id: 'setup.territory.header.description' }),
    timezone: translate({ id: 'setup.territory.timezone' }),
    borderRestrictionLabel: translate({ id: 'setup.territory.borderRestriction' }),
    borderRestrictionNote: translate({ id: 'setup.territory.borderRestriction.note' }),
    noBorderRestriction: translate({ id: 'setup.territory.borderRestriction.empty' }),
    planningRange: translate({ id: 'setup.territory.planningRange' }),
    days: translate({ id: 'setup.territory.days' }),
    edit: translate({ id: 'setup.territory.edit' }),
    storageTitle: translate({ id: 'setup.territory.storage.title' }),
    storageLinearProgressLabel: (currentOrders: number, totalOrders: number) =>
      translate({
        id: 'setup.territory.storage.linearProgress.label',
        values: { currentOrders, totalOrders },
      }),
    storageAlertWarningTitle: translate({ id: 'setup.territory.storage.alert.warning.title' }),
    storageAlertWarningDescription: translate({
      id: 'setup.territory.storage.alert.warning.description',
    }),
    storageAlertErrorTitle: translate({ id: 'setup.territory.storage.alert.error.title' }),
    storageAlertErrorDescription: translate({
      id: 'setup.territory.storage.alert.error.description',
    }),
    storageAlertErrorFullTitle: translate({ id: 'setup.territory.storage.alert.errorFull.title' }),
    storageAlertErrorFullDescription: translate({
      id: 'setup.territory.storage.alert.errorFull.description',
    }),
    storageAlertErrorFullDescriptionSimulation: translate({
      id: 'setup.territory.storage.alert.errorFull.description.simulation',
    }),
    storageAlertErrorFullContentOne: translate({
      id: 'setup.territory.storage.alert.errorFull.contentOne',
    }),
    storageAlertErrorFullContentTwoWithDate: (date: string) =>
      translate({
        id: 'setup.territory.storage.alert.errorFull.contentTwo.withDate',
        values: { date },
      }),
    storageAlertErrorFullContentTwoWithDateId:
      'setup.territory.storage.alert.errorFull.contentTwo.withDate',
    storageAlertErrorFullContentTwoWithoutDate: translate({
      id: 'setup.territory.storage.alert.errorFull.contentTwo.withoutDate',
    }),
    storageAlertErrorFullContentTwoWithoutDateId:
      'setup.territory.storage.alert.errorFull.contentTwo.withoutDate',
    suggestedActionsTitle: translate({ id: 'setup.territory.suggestedActions.title' }),
    suggestedAction1: translate({ id: 'setup.territory.suggestedActions.action1' }),
    suggestedAction2: translate({ id: 'setup.territory.suggestedActions.action2' }),
    suggestedActionsReviewButtonText: translate({
      id: 'setup.territory.suggestedActions.reviewButtonText',
    }),
    restoreOrdersTitle: translate({ id: 'setup.territory.restoreOrders.title' }),
    restoreOrdersDescriptionId: 'setup.territory.restoreOrders.description',
    restoreOrdersButtonText: translate({ id: 'setup.territory.restoreOrders.buttonText' }),
    restoreOrdersSuccess: translate({ id: 'setup.territory.restoreOrders.success' }),
    customNotificationTitle: translate({
      id: 'setup.territory.restoreOrders.customNotification.title',
    }),
    recurrentOrdersQueueAlertTitle: translate({
      id: 'setup.territory.storage.alert.queue.title',
    }),
    recurrentOrdersQueueAlertContentId: 'setup.territory.storage.alert.queue.content',
    transactionInProgressTitle: translate({
      id: 'global.disabledTooltip.transactionInProgress.title',
    }),
    transactionInProgressSubtitle: translate({
      id: 'global.disabledTooltip.transactionInProgress.subtitle',
    }),
  }))

  return api
}
